export enum AdminCosmeticListAction {
  Create,
}
